export type TravelerLoadState = 'forbidden' | 'error' | 'ready';

export const travelerLoadState = (errors: unknown[]): TravelerLoadState => {
  const statuses = errors.map(
    (error) =>
      (error as { response?: { status?: number } } | undefined)?.response
        ?.status,
  );
  if (statuses.includes(403)) return 'forbidden';
  if (errors.some(Boolean)) return 'error';
  return 'ready';
};

export const travelerPageWithinRange = (
  selectedPage: number,
  availablePages: number | undefined,
) => Math.min(selectedPage, Math.max(availablePages ?? 1, 1));
